module.exports = __webpack_public_path__ + "static/media/no_data_found.44ec40df.png";